import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";

import Navbar from "./component/homepage/Navbar";
import Footer from "./component/homepage/Footer";
import ScrollToTop from "./component/ScrollToTop";
import Homepage from "./component/homepage/Homepage";
import Dashboard from "./component/Dashboard/Dashboard";
import ContactUs from "./component/homepage/contactus";
import Blogs from "./component/Navlinkpage/Blogs";
import Storysuccess from "./component/Navlinkpage/Storysuccess";
import Aboutus from "./component/Navlinkpage/Aboutus";
import News from "./component/Navlinkpage/News";
import Admin_login from "./component/admin/admin_auth/Admin_login";
import Admin from "./component/admin/Admin";
import Termandcondition from "./component/homepage/policies/Termandcondition";
import Privacypolicy from "./component/homepage/policies/Privacypolicy";
import Disclaimer from "./component/homepage/policies/Disclaimer";
import Refundpolicy from "./component/homepage/policies/Refundpolicy";
import Register_paynow from "./component/auth/Register_paynow";
import Login_otp from "./component/auth/Login_otp";
import UploadWindow from "./component/admin/workshop/UploadWindow";
import UploadCommunityPage from "./component/admin/Community/UploadCommunityPage";
import UploadStudymaterialPage from "./component/admin/Study_material/UploadStudymaterialPage";

function App() {
  const storedTheme = localStorage.getItem("theme") || "light";
  const [theme, setTheme] = useState(storedTheme);

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <Router>
      <ScrollToTop />
      <ConditionalWrapper>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="blog" element={<Blogs />} />
          <Route path="story_success" element={<Storysuccess />} />
          <Route path="about_us" element={<Aboutus />} />
          <Route path="dashboard/*" element={<Dashboard />} />
          <Route path="contact_us" element={<ContactUs />} />
          <Route path="news" element={<News />} />
          <Route path="/terms" element={<Termandcondition />} />
          <Route path="privacy" element={<Privacypolicy />} />
          <Route path="disclaimer" element={<Disclaimer />} />
          <Route path="refundpolicy" element={<Refundpolicy />} />
          <Route path="admin_dash/*" element={<Admin />} />
          <Route path="admin" element={<Admin_login />} />
          <Route path="/Reg_pay" element={<Register_paynow />} />
          <Route path="/upload-workshop-form" element={<UploadWindow />} />
          <Route path="/uploadcommunitypage" element={<UploadCommunityPage />} />
          <Route path="/study-upload-page" element={<UploadStudymaterialPage />} />

        </Routes>
      </ConditionalWrapper>
    </Router>
  );
}

function ConditionalWrapper({ children }) {
  const location = useLocation();
  const hideHeaderFooter =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/admin_dash") || 
    location.pathname.startsWith("/upload-workshop-form") ||  
    location.pathname.startsWith("/uploadcommunitypage")  ||
    location.pathname.startsWith("/study-upload-page")  

  return (
    <>
      {!hideHeaderFooter && <Navbar />}
 
      {children}
      {!hideHeaderFooter && <Footer />}
      <Login_otp />
    </>
  );
}

export default App;
